<template>
  <!-- 页脚 -->
  <footer class="bg-white border-t border-slate-200 pt-16 pb-8">
    <div class="max-w-[1440px] mx-auto px-6">
      <div class="grid grid-cols-2 md:grid-cols-5 gap-12 mb-16">
        <!-- 品牌信息 -->
        <div class="col-span-2">
          <div class="flex items-center space-x-2 mb-6">
            <div class="w-8 h-8 bg-blue-600 rounded flex items-center justify-center text-white">
              <IconifyIcon icon="mdi:handshake" />
            </div>
            <span class="text-lg font-bold text-blue-900 uppercase">神通债权</span>
          </div>
          <p class="text-slate-500 text-sm max-w-sm mb-6 leading-relaxed">
            国内领先的债权债务全流程服务平台，致力于构建诚信、透明、高效的债务处理生态系统。
          </p>
          <!-- <div class="flex space-x-4">
            <IconifyIcon class="text-slate-400 text-2xl hover:text-blue-600 cursor-pointer" icon="mdi:wechat" />
            <IconifyIcon class="text-slate-400 text-2xl hover:text-blue-600 cursor-pointer" icon="mdi:sina-weibo" />
          </div> -->
        </div>
        
        <!-- 快速链接 -->
        <div>
          <h4 class="font-bold mb-6">快速链接</h4>
          <ul class="space-y-4 text-sm text-slate-500">
            <li>
              <router-link to="/square" class="hover:text-blue-600">信息广场</router-link>
            </li>
            <li>
              <router-link to="/publish" class="hover:text-blue-600">发布债权</router-link>
            </li>
          </ul>
        </div>
        
        <!-- 关于我们 -->
        <div>
          <h4 class="font-bold mb-6">关于我们</h4>
          <ul class="space-y-4 text-sm text-slate-500">
            <li>
              <router-link to="/about" class="hover:text-blue-600">平台介绍</router-link>
            </li>
            <li>
              <router-link to="/about" class="hover:text-blue-600">资质证书</router-link>
            </li>
            <li>
              <router-link to="/contact" class="hover:text-blue-600">商务合作</router-link>
            </li>
          </ul>
        </div>
        
        <!-- 联系支持 -->
        <div>
          <h4 class="font-bold mb-6">联系支持</h4>
          <ul class="space-y-4 text-sm text-slate-500">
            <li>
              <router-link to="/customer-service" class="hover:text-blue-600">在线客服</router-link>
            </li>
            <li>
              <router-link to="/contact" class="hover:text-blue-600">联系电话</router-link>
            </li>
            <li>
              <router-link to="/contact" class="hover:text-blue-600">企业微信</router-link>
            </li>
            <li>
              <router-link to="/contact" class="hover:text-blue-600">投诉建议</router-link>
            </li>
          </ul>
        </div>
      </div>
      
      <!-- 版权信息 -->
      <div class="border-t border-slate-100 pt-8 flex flex-col md:flex-row items-center justify-between text-xs text-slate-400">
        <p>© 2026 神通债权债务交易平台 版权所有 | <a :href="beian_url" target="_blank" class="hover:text-blue-600">{{ beian_no }}</a></p>
        <div class="flex space-x-6 mt-4 md:mt-0">
          <router-link :to="{ path: '/agreement', query: { type: '1' } }" class="hover:text-blue-600">服务协议</router-link>
          <router-link :to="{ path: '/agreement', query: { type: '3' } }" class="hover:text-blue-600">隐私政策</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getIndex } from '@/api/index'
export default {
  name: 'AppFooter',
  data() {
    return {
      beian_no: '',
      beian_url: ''
    }
  },
  created() {
    this.getFooterInfo()
  },
  methods: {
    async getFooterInfo() {
      const res = await getIndex()
      if (res.status == 200) {
        this.beian_no = res.data.beian_no || ''
        this.beian_url = res.data.beian_url || ''
      }
    }
  }
}
</script>

<style scoped>
</style>
